<template>
        <v-col cols="12" sm="12" md="4" class="my-5">
            <h2 class="text-center">{{ title }}</h2>
            <v-card class="mx-auto mb-0 px-3 pb-2" width="90%" flat  v-for="frontend in languages" :key="frontend.title">
                <v-card-text>{{ frontend.title }}</v-card-text>
                <v-progress-linear :color="frontend.color" height="15" :value="frontend.per">
                <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                </template>
                </v-progress-linear>
                <v-divider></v-divider>
            </v-card>
        </v-col>
</template>

<script>
export default {
    props: ['languages', 'title']
}
</script>